/** Kanban 共通スタイル（列 neutral・カード compact） */

/** 5ステータス均等幅（各20%相当） */
export const KANBAN_GRID_TEMPLATE = 'repeat(5, minmax(0, 1fr))';

export const KANBAN_COLUMN =
  'flex flex-col min-w-0 w-full flex-shrink-0 lg:w-full bg-prodia-background border border-prodia-border rounded-lg';

/** 横スクロール時の列最小幅（5列共通） */
export const KANBAN_COLUMN_MIN_WIDTH = '11rem';

export const KANBAN_COLUMN_HEADER =
  'px-2 py-1.5 border-b border-prodia-border bg-prodia-surface rounded-t-lg';

export const KANBAN_COLUMN_BODY =
  'flex flex-col gap-1.5 p-1.5 min-h-[64px] max-h-[58vh] overflow-y-auto';

export const KANBAN_CARD =
  'group relative w-full min-w-0 bg-prodia-surface border border-prodia-border border-l-2 rounded-lg p-2 shadow-prodia cursor-grab active:cursor-grabbing transition-[box-shadow,border-color] hover:border-slate-300 hover:shadow-prodia-md [overflow-wrap:anywhere]';

export const KANBAN_CARD_DRAGGING =
  'ring-2 ring-prodia-primary/40 shadow-prodia-md opacity-60 cursor-grabbing';

export const KANBAN_DROP_ZONE =
  'border-2 border-dashed border-prodia-primary/40 bg-prodia-primary-subtle/50';

/** 列ID → ヘッダー左ドット色（Tailwind bg class） */
export const KANBAN_COLUMN_DOT = {
  scheduling: 'bg-warning',
  scheduled: 'bg-info',
  completed: 'bg-prodia-text-muted',
  won: 'bg-success',
  lost: 'bg-prodia-text-muted',
  declined: 'bg-prodia-text-muted',
};

/** ステータス文字列 → semantic Badge variant（カード内表示用） */
export function statusToBadgeVariant(status) {
  const s = String(status || '');
  if (s.startsWith('日程調整')) return 'warning';
  if (s.startsWith('面談予定')) return 'info';
  if (s.includes('回答待ち') || s.startsWith('面談済み') || s === '回答待ち') return 'info';
  if (s === '成約' || s.startsWith('成約')) return 'success';
  if (s === '見送り' || s === 'お見送り') return 'neutral';
  return 'neutral';
}
